import { Controller } from '@hotwired/stimulus';
import tippy, { roundArrow, sticky } from 'tippy.js';

export default class extends Controller {
  static values = {
    message: String,
    duration: {
      type: Number,
      default: 3000,
    },
  };

  connect() {
    this.tippyEl = tippy(this.element, {
      showOnCreate: true,
      interactiveBorder: 10,
      content: this.messageValue,
      appendTo: this.element,
      allowHTML: true,
      interactive: true,
      sticky: true,
      arrow: roundArrow,
      plugins: [sticky],
      placement: 'auto',
    });

    setTimeout(() => {
      this.tippyEl.destroy();
    }, this.durationValue);
  }

  disconnect() {
    this.tippyEl.destroy();
  }
}
